<template>
  <div class="dropdown">
    <button @click="teleport.dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle btn-icon clear-area controllers">
      <icon class="kebab"></icon>
      <span class="sr-only">More Actions Dropdown</span>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ruleMoreOptions">
      <li v-if="canMoveUp">
        <button class="dropdown-item" @click="moveUp">Move Up</button>
      </li>
      <li v-if="canMoveDown">
        <button class="dropdown-item" @click="moveDown">Move Down</button>
      </li>
      <li v-if="canMoveOutsideBefore">
        <button class="dropdown-item" @click="moveOutsideBefore">Move outside before this block</button>
      </li>
      <li v-if="canMoveOutsideAfter">
        <button class="dropdown-item" @click="moveOutsideAfter">Move outside after this block</button>
      </li>
      <li v-if="canMoveInsideBefore">
        <button class="dropdown-item" @click="moveInsideBefore">Move inside the block above</button>
      </li>
      <li v-if="canMoveInsideAfter">
        <button class="dropdown-item" @click="moveInsideAfter">Move inside the block below</button>
      </li>
      <li v-if="canMoveUp || canMoveDown || canMoveOutsideBefore || canMoveOutsideAfter || canMoveInsideAfter">
        <hr>
      </li>
      <li>
        <button class="dropdown-item" @click="addConditionBelow">Add condition below</button>
      </li>
      <li>
        <button class="dropdown-item" @click="addConditionAbove">Add condition above</button>
      </li>
      <li>
        <button class="dropdown-item" @click="addConditionSetBelow">Add condition block below</button>
      </li>
      <li>
        <button class="dropdown-item" @click="addConditionSetAbove">Add condition block above</button>
      </li>
      <li>
        <hr>
      </li>
      <li>
        <button class="dropdown-item" @click="deleteRule">
          Delete {{isRule ? 'Item' : 'Block'}}
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {teleport} from '~/modules/nodeManager';
  import ConditionalRuleSet from "../../models/conditionalRules/conditionalRuleSet";
  import ConditionalRule from "../../models/conditionalRules/conditionalRule";

  export default Vue.extend({
    props: ['model'],
    mixins: [],
    components: {
    },
    data() {
      return {
        teleport: teleport
      }
    },
    computed: {
      canMoveUp(): boolean {
        return this.model.sort_order > 0;
      },
      canMoveDown(): boolean {
        return this.model.sort_order < Object.keys(this.model.parent.conditional_rules).length - 1;
      },
      canMoveOutsideBefore(): boolean {
        return this.model.parent.parent instanceof ConditionalRuleSet;
      },
      canMoveOutsideAfter(): boolean {
        return this.model.parent.parent instanceof ConditionalRuleSet;
      },
      canMoveInsideBefore(): boolean {
        return this.prevRule instanceof ConditionalRuleSet;
      },
      canMoveInsideAfter(): boolean {
        return this.nextRule instanceof ConditionalRuleSet;
      },
      prevRule(): ConditionalRuleSet | ConditionalRule {
        return this.ruleAt(this.model.sort_order - 1);
      },
      nextRule(): ConditionalRuleSet | ConditionalRule {
        return this.ruleAt(this.model.sort_order + 1);
      },
      isRule(): boolean {
        return this.model instanceof ConditionalRule;
      },
    },
    methods: {
      ruleAt(sortOrder: number): ConditionalRuleSet | ConditionalRule {
        for (let k in this.model.parent.conditional_rules) {
          if (this.model.parent.conditional_rules[k].sort_order === sortOrder) {
            return this.model.parent.conditional_rules[k];
          }
        }
      },
      deleteRule(): void {
        this.model.delete();
        this.setOrderFor(null, this.model.sort_order);
      },
      moveUp(): void {
        let otherRule = this.ruleAt(this.model.sort_order - 1);
        if (otherRule) {
          otherRule.sort_order++
        }
        this.model.sort_order--;
      },
      moveDown(): void {
        let otherRule = this.ruleAt(this.model.sort_order + 1);
        if (otherRule) {
          otherRule.sort_order--;
        }
        this.model.sort_order++;
      },
      moveOutsideBefore(): void {
        this.changeParent(this.model, this.model.parent.parent, this.model.parent.sort_order);
      },
      moveOutsideAfter(): void {
        this.changeParent(this.model, this.model.parent.parent, this.model.parent.sort_order + 1);
      },
      moveInsideBefore(): void {
        let prevRule = this.prevRule;
        this.changeParent(this.model, prevRule, prevRule.conditionalRulesArray.length);
      },
      moveInsideAfter(): void {
        let nextRule = this.nextRule;
        this.changeParent(this.model, nextRule, 0);
      },
      addConditionBelow(): void {
        let newRule = this.model.parent.addNewRule(false);
        this.setOrderFor(newRule, this.model.sort_order + 1);

      },
      addConditionAbove(): void {
        let newRule = this.model.parent.addNewRule(false);
        this.setOrderFor(newRule, this.model.sort_order);
      },
      addConditionSetBelow(): void {
        let newRuleSet = this.model.parent.addNewRuleSet(false);
        this.setOrderFor(newRuleSet, this.model.sort_order + 1);
      },
      addConditionSetAbove(): void {
        let newRuleSet = this.model.parent.addNewRuleSet(false);
        this.setOrderFor(newRuleSet, this.model.sort_order);
      },
      setOrderFor(rule, sortOrder) {
        if (rule) {
          rule.sort_order = sortOrder;
        }
        for (let conditional of this.model.parent.conditionalRules) {
          if (conditional.sort_order >= sortOrder) {
            if (rule === null) {
              // removing an item
              conditional.sort_order--;
            } else if (conditional !== rule) {
              conditional.sort_order++;
            }
          }
        }
      },
      changeParent(rule, newParent, sortOrder) {
        rule.parent.trackCreationDeletion(rule.client_id, rule.asJson(), null, rule);
        Vue.delete(rule.parent.conditional_rules, rule.client_id);
        this.setOrderFor(null, rule.sort_order);
        Vue.set(newParent.conditional_rules, rule.client_id, rule);
        rule.parent = newParent;
        this.setOrderFor(rule, sortOrder);
        newParent.trackCreationDeletion(rule.client_id, null, rule.asJson(), rule);
      }
    },
  });
</script>
